import Vue from 'vue'
import axios from 'axios'
import { loginWithRefreshToken } from './commonFunction'

axios.interceptors.request.use(function (config) {
  let data = config.method.toUpperCase() === 'GET' || config.method.toUpperCase() === 'DELETE' ? config.params : config.data
  if (config.requestForSearchable !== undefined) {
    config.baseURL = process.env.VUE_APP_COMMON_URL
  } else {
    config.baseURL = process.env.VUE_APP_WEB_URL
  }
  if (!config.removeCommonParams) {
    const accessToken = localStorage.getItem(process.env.VUE_APP_LSACCESSTOKENKEY)
    if (typeof data === 'undefined' || typeof data === 'object') {
      data = (typeof data === 'undefined') ? {} : data
      data.access_token = accessToken
      data.request_from = 'clientApp'
    } else if (typeof data === 'string') {
      data += '&access_token=' + accessToken
      data += '&request_from=clientApp'
    }
    if (config.method.toUpperCase() === 'GET' || config.method.toUpperCase() === 'DELETE') {
      config.params = data
    } else {
      config.data = data
    }
  }
  Vue.prototype.$eventBus.$emit('$displayMainLoader', (config.mainLoader !== undefined ? config.mainLoader : true))
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (config) {
  Vue.prototype.$eventBus.$emit('$displayMainLoader', false)
  return config
}, async function (error) {
  Vue.prototype.$eventBus.$emit('$displayMainLoader', false)
  if (error.response.status === 401) {
    const response = await loginWithRefreshToken()
    if (response.status === 200) {
      localStorage.setItem(process.env.VUE_APP_LSACCESSTOKENKEY, response.data.access_token)
      localStorage.setItem(process.env.VUE_APP_LSREFRESHTOKENKEY, response.data.refresh_token)
      if (error.config.method.toUpperCase() !== 'GET' && error.config.method.toUpperCase() !== 'DELETE') {
        error.config.data = JSON.parse(error.config.data)
      }
      return axios.request(error.config)
    } else {
      Vue.prototype.$userLoggedOut()
      window.location.href = '/#/login'
      return Promise.reject(error)
    }
  } else {
    return Promise.reject(error)
  }
})
